module.exports = __webpack_public_path__ + "static/media/new_suppliers.33d59455.jpg";